import {activeTab} from "../config.ts";

export const changeTab = (index: number) => {
    activeTab.value = index;
    // 更新 URL 中的 tab 参数
    window.history.pushState(null, '', `?tab=${index}`);
};